module.exports = __webpack_public_path__ + "media/images/emblems/Dompierre-drapeau-334cd4d9198656d318b9dce1319a762a.png";